var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCloseCard = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 44 44",
  fill: "none",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.9999 1.83337C33.1377 1.83337 42.1666 10.8623 42.1666 22C42.1666 33.1378 33.1377 42.1667 21.9999 42.1667C10.8622 42.1667 1.83325 33.1378 1.83325 22C1.83325 10.8623 10.8622 1.83337 21.9999 1.83337ZM21.9999 5.50004C12.8872 5.50004 5.49992 12.8873 5.49992 22C5.49992 31.1127 12.8872 38.5 21.9999 38.5C31.1126 38.5 38.4999 31.1127 38.4999 22C38.4999 12.8873 31.1126 5.50004 21.9999 5.50004ZM19.0926 21.6855L15.2036 17.7964C14.4876 17.0804 14.4876 15.9196 15.2036 15.2037C15.9195 14.4877 17.0803 14.4877 17.7963 15.2037L21.6854 19.0928L25.5745 15.2037C26.2904 14.4877 27.4512 14.4877 28.1672 15.2037C28.8831 15.9196 28.8831 17.0804 28.1672 17.7964L24.2781 21.6855L28.1672 25.5746C28.8831 26.2905 28.8831 27.4513 28.1672 28.1673C27.4512 28.8833 26.2904 28.8833 25.5745 28.1673L21.6854 24.2782L17.7963 28.1673C17.0803 28.8833 15.9195 28.8833 15.2036 28.1673C14.4876 27.4513 14.4876 26.2905 15.2036 25.5746L19.0926 21.6855Z",
  fill: "black"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close-card.694143ab.svg";
export { ForwardRef as ReactComponent };